export default [
  // 业务员积分
  {
    path: 'salesman-points',
    name: 'SalesmanPoints',
    meta: {
      inTab: true,
      isDynamic: true,
      id: '团队业务积分'
    },
    component: () =>
      import(
        /* webpackChunkName: "SalesmanPoints" */ '@/views/PointsManage/SalesmanPoints/index.vue'
      )
  },
  {
    path: 'platform-points',
    name: 'PlatformPoints',
    meta: {
      inTab: true,
      isDynamic: true,
      id: '平台业务积分'
    },
    component: () => import('@/views/PointsManage/SalesmanPoints/index.vue')
  }
];
